import { forwardRef } from 'react'
import { Body, Box, CenteredBox } from '..'
import './SelectButtons.scss'

export const SelectButtons = forwardRef(function SelectButtons({ selectedIndex, items, onClick, fullWidth, size, buttonRefIndex }, ref) {
  return (
    <Box
      p={4}
      gap={8}
      background="white"
      className="select-buttons"
      fullWidth={fullWidth}
    >
      {items.map((item, i) =>
        <CenteredBox
          key={i}
          fullHeight
          fullWidth={fullWidth}
          cursor={selectedIndex === i ? 'default' : 'pointer'}
          background={selectedIndex === i && 'var(--blue)'}
          color={selectedIndex === i ? 'white' : 'black'}
          onClick={() => onClick(i)}
          ref={buttonRefIndex === i ? ref : undefined}
        >
          <Body alt bold noWrap size={size && size}>
            {item}
          </Body>
        </CenteredBox>
      )}
    </Box>
  )
})
